import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { t } from 'i18next';
import { enqueueSnackbar } from 'notistack';

export const useCheckoutSessionParamMessages = () => {
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('checkoutSuccess') === 'true') {
      enqueueSnackbar(t('checkoutSuccess'), { variant: 'success' });
    } else if (searchParams.get('checkoutCanceled') === 'true') {
      enqueueSnackbar(t('purchaseCancelled'), { variant: 'info' });
    }
  }, [searchParams]);
};
